import {FC, useMemo} from "react";
import styled from "@emotion/styled";
import ReactAwesomePlayer from "react-awesome-player";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background: ${({theme}) => theme.colorPalette.black};
	color: ${({theme}) => theme.colorPalette.white};
	font-family: "Hind", sans-serif;
	text-align: left;
	min-height: 150px;

	@media (min-width: ${breakpoints.medium}) {
		flex-direction: row;
	}
`;

const VideoContainer = styled.div`
	width: 100%;

	.react-awesome-player-container {
		video {
			background: #1c1c1c;
		}

		.vjs-big-play-button {
			background: ${({theme}) => theme.colorPalette.primary};
		}

		&:hover .vjs-big-play-button {
			background: ${({theme}) => theme.colorPalette.primary};
		}
	}

	@media (min-width: ${breakpoints.medium}) {
		width: 50%;
		min-height: 100%;
	}
`;

const Content = styled.div`
	display: flex;
	align-items: center;
	flex-grow: 1;
	padding: 12px 20px;

	@media (min-width: ${breakpoints.medium}) {
		width: 50%;
	}
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 16px;
	line-height: 120%;
	letter-spacing: 0.02em;
`;

interface INewsVideoArticle {
	title: string;
	src: string;
}

export const NewsVideoArticle: FC<INewsVideoArticle> = ({title, src}) => {
	const videoOptions = useMemo(
		() => ({
			preload: "auto",
			sources: [
				{
					type: "video/mp4",
					src,
				},
			],
		}),
		[src]
	);

	return (
		<Wrapper>
			<VideoContainer>
				<ReactAwesomePlayer options={videoOptions} />
			</VideoContainer>

			<Content>
				<Title>{title}</Title>
			</Content>
		</Wrapper>
	);
};
